// src/features/agent-builder/components/KnowledgeKeeperTeaser.tsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BookOpen } from 'lucide-react'; // Or your preferred "book/librarian" icon
import { Button, Tooltip } from '@dopomogai/ui';

export const KnowledgeKeeperTeaser: React.FC = () => {
  const { t } = useTranslation('agentBuilder');

  return (
    <div className="mt-6 p-5 bg-sky-50 border-2 border-sky-200 rounded-xl shadow-sm">
      <div className="flex items-start gap-4">
        <div className="shrink-0 p-2 bg-white rounded-full border-2 border-sky-300">
          <BookOpen size={28} className="text-sky-600" aria-hidden="true" />
        </div>
        <div className="flex-grow">
          <h3 className="text-lg font-semibold text-sky-800">
            {/* i18n: agentBuilder.step2.knowledgeKeeper.title = "Knowledge Keeper Assistant" */}
            {t('step2.knowledgeKeeper.title')}
          </h3>
          <p className="mt-1 text-sm text-sky-700 leading-relaxed">
            {/* i18n: agentBuilder.step2.knowledgeKeeper.description = "Our AI Knowledge Keeper helps you build and maintain a powerful knowledge base. It assists with organizing uploaded files, suggests improvements for your website scrape, and will soon help manage personalized customer knowledge." */}
            {t('step2.knowledgeKeeper.description')}
          </p>
          <div className="mt-3">
            <Tooltip
              textKey="agentBuilder:step2.knowledgeKeeper.activateTooltip"
              // text={t('step2.knowledgeKeeper.activateTooltip')} // "Enable advanced AI assistance for managing and optimizing your knowledge sources."
            >
              <Button
                textKey="agentBuilder:step2.knowledgeKeeper.activateButton"
                // text={t('step2.knowledgeKeeper.activateButton')} // "[✨ Activate Knowledge Keeper (Coming Soon)]"
                variant="outline" // Or a custom "teaser" variant
                size="sm"
                disabled
                icon={<BookOpen size={14} />} // Example icon consistency
                className="opacity-70 cursor-not-allowed border-sky-400 text-sky-700 hover:border-sky-500" // Custom teaser styling
              />
            </Tooltip>
          </div>
        </div>
      </div>
    </div>
  );
};